<mat-card class="qaroni-card-bg-background mat-elevation-z0">
  <mat-card-content class="flex flex-col gap-3 p-4">
    <h3 class="m-0 flex items-center gap-2 text-base font-bold text-primary-30">
      <ng-container i18n>Avisos</ng-container>
      @if (warningsCount) {
        <span
          class="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-accent px-1.5 text-xs text-accent-20"
          >{{ warningsCount }}</span
        >
      }
    </h3>

    @if (!warningsCount) {
      <p class="m-0 flex items-center gap-2 text-sm text-neutral-40">
        <mat-icon class="qaroni-text-success">check_circle</mat-icon>
        <ng-container i18n>Sin avisos para esta solicitud.</ng-container>
      </p>
    }

    <ng-content />

    @if (collision(); as collision) {
      @if (collision.flagError && collision.totalCollision) {
        <div
          @toggleHeight
          class="flex items-start gap-2.5 rounded-md border border-warn-80 bg-warn-95 px-3.5 py-3 text-sm leading-normal text-warn-20"
          role="alert">
          <mat-icon class="shrink-0 text-danger">error</mat-icon>
          <div>
            <strong class="block" i18n>Fechas</strong>
            <span i18n>El tipo de permiso y ausencia</span>
            "{{ collision.absence }}"
            <span i18n>tiene un tiempo máximo de</span>
            <qaroni-absences-units-preview
              [unit]="unit()"
              [time]="collision.timeMax" />
            <span i18n> y tiene un total de</span>
            {{ collision.totalCollision }}
            {{ collision.totalCollision | i18nPlural: totalCollisionMapping }}
            <span i18n> para las horas o fechas ingresadas</span>
          </div>
        </div>
      }
      @if (collision.flagError && !collision.totalCollision) {
        <div
          @toggleHeight
          class="flex items-start gap-2.5 rounded-md border border-warn-80 bg-warn-95 px-3.5 py-3 text-sm leading-normal text-warn-20"
          role="alert">
          <mat-icon class="shrink-0 text-danger">error</mat-icon>
          <div>
            <strong class="block" i18n>Fechas</strong>
            <span i18n>El tipo de permiso y ausencia</span>
            "{{ collision.absence }}"
            <span i18n>tiene un tiempo máximo de</span>
            <qaroni-absences-units-preview
              [unit]="unit()"
              [time]="collision.timeMax" />
          </div>
        </div>
      }
      @if (collision.totalCollision && !collision.flagError) {
        <div
          @toggleHeight
          class="flex items-start gap-2.5 rounded-md border border-accent-80 bg-accent-98 px-3.5 py-3 text-sm leading-normal text-accent-20"
          role="alert">
          <mat-icon class="shrink-0 text-accent-40">warning</mat-icon>
          <div>
            <strong class="block" i18n>Fechas</strong>
            <span i18n>El tipo de permiso y ausencia</span>
            "{{ collision.absence }}"
            <span i18n>tiene un total de</span>
            {{ collision.totalCollision }}
            {{ collision.totalCollision | i18nPlural: totalCollisionMapping }}
            <span i18n> para las horas o fechas ingresadas</span>
          </div>
        </div>
      }
    }

    @if (fileRequired()) {
      <div
        @toggleHeight
        class="flex items-start gap-2.5 rounded-md border border-warn-80 bg-warn-95 px-3.5 py-3 text-sm leading-normal text-warn-20"
        role="alert">
        <mat-icon class="shrink-0 text-danger">error</mat-icon>
        <div>
          <strong class="block" i18n>Adjuntos</strong>
          <ng-container i18n>
            Este tipo de permiso y ausencia requiere adjuntar al menos un
            archivo
          </ng-container>
        </div>
      </div>
    }
  </mat-card-content>
</mat-card>
